<template>
  <section class="accreditations" v-if="misc && misc.logos_image">
    <div class="inner">
      <img :src="misc.logos_image" alt="Find us on these popular sites" />
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"

export default {
  computed: {
    ...mapState(["misc"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.accreditations {
  padding: 4rem 0;
  text-align: center;
}
</style>
